<template>
  <div>
    <banner />
    <search-bar />
    <section class="container mb-4">
      <div class="filter-buttons d-flex justify-content-center w-100 flex-wrap mb-0">
        <button class="col-11 col-sm-5 col-md-5 col-lg-2 m-2 buttons-filter"
          :class="{ activeButtons: categoriaFiltro === 'todos' }" @click="categoriaFiltro = 'todos'">
          <i class="fa fa-th mr-2"></i>Todos
        </button>
        <button class="col-11 col-sm-5 col-md-5 col-lg-3 m-2 buttons-filter"
          :class="{ activeButtons: categoriaFiltro === 'veiculo' }" @click="categoriaFiltro = 'veiculo'">
          <i class="fa fa-car mr-2"></i>Veículos
        </button>
        <button class="col-11 col-sm-5 col-md-5 col-lg-3 m-2 buttons-filter"
          :class="{ activeButtons: categoriaFiltro === 'imovel' }" @click="categoriaFiltro = 'imovel'">
          <i class="fa fa-home mr-2"></i>Imóveis
        </button>
        <button class="col-11 col-sm-5 col-md-5 col-lg-3 m-2 buttons-filter"
          :class="{ activeButtons: categoriaFiltro === 'outros' }" @click="categoriaFiltro = 'outros'">
          <i class="fa fa-cubes mr-2"></i>Outros Bens
        </button>
      </div>
    </section>
    <leiloesDestaque :filtro-categoria-id="filtroAtivo.categoriaId" />
    <section class="container-fluid p-0" v-if="banner">
      <div class="banner-fixo">
        <img class="w-100" :src="banner" />
      </div>
    </section>
    <LotesDestaque />
    <newsletter />
    <cookie-law theme="base--rounded" buttonText="Aceito" class="cookies" :buttonDecline="true"
      buttonDeclineText="Ignorar">
      <div slot="message">
        <p>
          Esse site utiliza
          <a href="https://www.kaspersky.com.br/resource-center/definitions/cookies" target="_blank"
            rel="noopener noreferrer">cookies</a>
          para uma melhor experiência do usuário, fornecer funcionalidades personalizadas e analisar nosso tráfego. Ao
          continuar você declara o
          aceite.
        </p>
        <p>
          <small>
            Não compartilhamos nenhum dado com terceiros e os mesmos serão utilizados única e exclusivamente para
            identificação no Leilão.
          </small>
        </p>
        <p>
          <small>
            <a href="/pagina/termos-de-privacidade">Política de Privacidade</a>
          </small>
        </p>
        <p>
          <small>
            <a href="/pagina/politica-de-cookies">Política de cookies</a>
          </small>
        </p>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar.vue';
import Newsletter from '@/components/Newsletter.vue';
import LeiloesDestaque from './components/LeiloesDestaque.vue';
import Banner from './components/Banner.vue';
import CookieLaw from 'vue-cookie-law';
import LotesDestaque from './components/LotesDestaque.vue';
export default {
  components: {
    LotesDestaque,
    LeiloesDestaque,
    Banner,
    CookieLaw,
    SearchBar,
    Newsletter,
  },
  data() {
    return {
      tab: 'aberto',
      fiteredLotes: '',
      searchLoteDestaque: '',
      banner: process.env.VUE_APP_BANNER_HOME,
      categoriaFiltro: 'todos',
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR,
    };
  },
  computed: {
    filtroAtivo() {
      switch (this.categoriaFiltro) {
        case 'veiculo':
          return { categoriaId: 1 };
        case 'imovel':
          return { categoriaId: 2 };
        case 'outros':
          return { categoriaId: 9 };
        default:
          return { categoriaId: 0 };
      }
    },
  },
};
</script>
<style scoped>
.cookies a {
  color: #4cb848;
  text-decoration: underline;
}

.banner-fixo {
  -webkit-box-shadow: inset 0px 15px 15px -15px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: inset 0px 15px 15px -15px rgba(0, 0, 0, 0.8);
  box-shadow: inset 0px 15px 15px -15px rgba(0, 0, 0, 0.8);
}

.buttons-filter {
  border-radius: 13px;
  border: 1px solid #ddd;
  color: v-bind(colorPrimary);
}

.activeButtons {
  background-color: v-bind(colorPrimary);
  color: v-bind(colorConstrast);
}
</style>
